import { createContext, DispatchWithoutAction } from 'react';

type MoraDialogState = {
  showDialog: DispatchWithoutAction;
};

/**
 * Contexto utilizado para notificar que el usuario se
 * encuentra en estado de mora.
 */
export const MoraDialogContext = createContext<MoraDialogState | null>(null);
